import { useQuery, useQueryClient } from "react-query";
import { ShortlistClient } from "services/motorpoint/user-context-api";
import type { UserContext, UserContextId } from "services/motorpoint/user-context-api/types";

export type ShortlistedVehicleType = {
    id: number;
    timestamp: number;
};

const shortlistClient = new ShortlistClient({
    useEnv: true,
});

export const QUERY_KEY = "favourites:shortlist";

const useShortlist = ({ userContextId }: UserContextId) => {
    const getByUserContextId = shortlistClient.getByUserContextId.bind(shortlistClient);
    const queryClient = useQueryClient();

    const { data: shortlist } = useQuery({
        queryKey: QUERY_KEY,
        queryFn: () => getByUserContextId({ userContextId }),
        retry: 3,
        retryDelay: (attemptIndex, error) => {
            return Math.pow(2, attemptIndex) * 200;
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            //update userContextMeta to update the counter in the header
            queryClient.setQueryData("userContext", (oldData: UserContext | undefined) => {
                return Object.assign({}, oldData, {
                    savedDataMeta: {
                        ...oldData?.savedDataMeta,
                        shortlistCount: data?.stockNumbers?.length ?? 0,
                    },
                });
            });
        },
    });

    return shortlist;
};

export default useShortlist;
